window.VegasOrder = {
	disabledCourier: false,
	disabledCdekCourier: false,
	disabledPickup: false,
	disabledBoxberryPvz: false,
	disabledBoxberryCourier: false,

	formorder: null,
	formOrder: function () {
		if (!this.formorder) {
			this.formorder = $("#form-order");
		}

		return this.formorder;
	},

	updateData: function () {
		let params = $("#form-order").serializeArray();
		params.push({
			name: 'get_cart_total_view',
			value: 1,
		});

		$.get('/cart/order/data', params, function (data) {
			VegasCart.total(data);
		});
	},
	renderPaymentsTypes: function () {
		let $form = $("#form-order");
		$form.find('.radio-selector.delivery').each(function () {
			let paymentsIds = $(this).find('.delivery-type-radio:checked').data('payments');

			var $cartOrder = $(this).closest('.cart-order');

			var $radioSelector = $cartOrder.find('.radio-selector.payment');
			$radioSelector.find('.payment-type-radio').each(function (i, e) {
				let $li = $(e).closest('li');

				if (paymentsIds === true || String(paymentsIds).split(',').includes($(e).val())) {
					$li.removeClass('disabled');
				} else {
					$li.addClass('disabled');
				}
			});

			$radioSelector.find('li:not(.disabled)')
				.first()
				.find('.payment-type-radio')
				.prop('checked', 'checked')
			;
		});
	},
	renderOrderButtons: function () {
		let $formOrder = $("#form-order");
		var selectedDelivery = $formOrder.find('.delivery-type-radio:checked').val();

		var $btnsOrder = $formOrder.find('.btn-next-order, .btn-make-order');

		let allDisabled = $formOrder.find('.radio-selector.delivery li:not(.disabled) .delivery-type-radio').length === 0;
		if (
			allDisabled
			|| (selectedDelivery == 1 && this.disabledCourier)
			|| (selectedDelivery == 3 && this.disabledCdekCourier)
			|| (selectedDelivery == 4 && this.disabledCdekPvz)
			|| (selectedDelivery == 5 && this.disabledBoxberryPvz)
			|| (selectedDelivery == 6 && this.disabledBoxberryCourier)
		) {
			$btnsOrder.attr('disabled', 'disabled');
		} else {
			$btnsOrder.removeAttr('disabled');
		}
	},
	showOrHideFIO: function () {
		var val = parseInt(this.formOrder().find('.delivery-type-radio:checked').val());

		let $cols = this.formOrder().find('.col-fname, .col-oname');

		if ([3, 4, 5, 6].indexOf(val) !== -1) {
			$cols.show();
			$cols.find('.form-control').attr('required', 'required');
		} else {
			$cols.hide();
			$cols.find('.form-control').removeAttr('required');
		}
	},
};